import { render, staticRenderFns } from "./ProductPic.vue?vue&type=template&id=546a6c5c&scoped=true"
import script from "./ProductPic.vue?vue&type=script&lang=js"
export * from "./ProductPic.vue?vue&type=script&lang=js"
import style0 from "./ProductPic.vue?vue&type=style&index=0&id=546a6c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a6c5c",
  null
  
)

export default component.exports